<div *ngIf="isConfirmed==false" style="padding:8px 8px">
    <h2>Reset your password</h2>
    <h4>Enter your email.</h4>
    <form method="post">
        <div asp-validation-summary="All" class="text-danger"></div>
        <div class="pds-form-field">
            <label class="pds-form-label">Email</label>
            <dx-text-box class="pds-form-value" [(ngModel)]="model.email" name="email"></dx-text-box>
        </div>
        <div class="pds-form-field">
            <label class="pds-form-label">Password</label>
            <dx-text-box class="pds-form-value" [(ngModel)]="model.password" name="password" mode="password"></dx-text-box>
        </div>
        <div class="pds-form-field">
            <label class="pds-form-label">Confirm Password</label>
            <dx-text-box class="pds-form-value" [(ngModel)]="model.confirmPassword" name="confirmPassword" mode="password"></dx-text-box>
        </div>
        <!--<label>Password must be 6 characters and contain an uppercase character, lowercase character, a digit, and a non-alphanumeric character</label>-->
        <dx-text-box style="border-width:0px;padding-left:0px;" [readOnly]="true" [(value)]="passwordRule"></dx-text-box>
        <br />
        <br />
        <dx-button [useSubmitBehavior]="true" type="default" (click)="buttonClick()" class="btn btn-default" text="Submit"></dx-button>
    </form>
</div>
<div *ngIf="isConfirmed==true">
    <h2>Reset password confirmation</h2>
    <p>
        Your password has been reset. Please <a [routerLink]="['/account','login']">click here to log in</a>.
    </p>
</div>